// Auth
export const apiLogin = '/auth/sign-in';
export const apiLogout = '/auth/log-out';
export const apiRefreshToken = '/auth/refresh';
export const apiForgotPass = '/auth/forgot-password';
export const apiUpdatePass = '/auth/update-password';
export const apiVerifyCode = '/auth/forgot-password/verify-code';

// Users
export const apiGetMe = '/users/me';
export const apiUsers = '/users';
export const apiImportUser = '/users/import';
export const apiChangePass = '/users/change-password';
export const apiUserCourses = '/users/courses';

// Files
export const apiFile = '/files';

// Admins
export const apiAdmins = '/admins';

// Courses
export const apiCourses = '/courses';

// Course Schedules
export const apiCourseSchedule = '/course-schedules';

export const apiRegions = '/course-schedules/regions';

// Settings
export const apiSetting = '/settings';

// News
export const apiNews = '/news';

// Inquiry
export const apiInquiry = '/inquiries';

// Faq
export const apiFaq = '/faqs';

// Studio
export const apiStudio = '/studio';

//seminals
export const apiSeminals = '/seminars';

// QR
export const apiQrCode = '/course-schedules';

//Course Registration
export const apiCourseRegistration = '/course-schedules-registration';

//CEUS
export const apiCeus = '/ceus';
